export const collectionRoles = [
    'Manager Cobranza',
    'cobranza',
]